// Store main items
const menu = document.querySelector('.foldoutMenu__navWrapper');
const menuTrigger = document.getElementById('foldoutMenu__trigger');
const menuMain = document.querySelector('.foldoutMenu__menu');

// Get menu items
const menuList = menu.querySelector('.foldoutMenu__menu>ul');
const subMenus = menu.querySelectorAll('.sub-menu');
const menuItemsWithChildrenContainer = menu.querySelectorAll('.menu-item-has-children');
const menuItemsWithChildren = menu.querySelectorAll('.menu-item-has-children>a');

// Store if sub-menu is open
let isOpenSubMenu = false;

function toggleMenu() {
  menu.classList.toggle('isOpen');
  menuTrigger.classList.toggle('isOpen');
  document.body.classList.toggle('menuOpen');
}

function clearClasses(clearSub = false, clearLi = false, clearUl = false, clearMain = false) {
  // Clear sub menu open classes
  if (clearSub) {
    subMenus.forEach((subMenu) => {
      subMenu.classList.remove('isOpen');
    });
    isOpenSubMenu = false;
  }

  // Clear ul class
  if (clearUl) {
    menuList.classList.remove('isOpen');
  }

  // Clear list items
  if (clearLi) {
    menuItemsWithChildrenContainer.forEach((item) => {
      item.classList.remove('isSelected');
    });
  }

  // Clear main menu open classes
  if (clearMain) {
    menu.classList.remove('isOpen');
    menuTrigger.classList.remove('isOpen');
    document.body.classList.toggle('menuOpen');
  }
}

function openSubMenu(event: Event) {
  // Prevent navigation
  event.preventDefault();

  // Get sub menu
  const target = event.target as HTMLAnchorElement;
  const subMenu = <HTMLElement>target.nextElementSibling;

  // Get list element
  const listEle = <HTMLElement>target.parentElement;

  // Remove sub menu classes
  clearClasses(true, true);

  // Add open class to ul element
  menuList.classList.add('isOpen');

  // Add open class to target
  subMenu.classList.add('isOpen');

  // Add open class to list element
  listEle.classList.add('isSelected');

  // Set sub menu to open
  isOpenSubMenu = true;
}

// Add listener to menu button
menuTrigger.addEventListener('click', toggleMenu, false);

// Add listener to all items with children
menuItemsWithChildren.forEach((menuItem) => {
  menuItem.addEventListener('click', openSubMenu, false);
});

// Add close listener to empty space in menu
menuMain.addEventListener('click', (event) => {
  if (event.target !== menuMain) {
    return;
  }

  if (isOpenSubMenu) {
    clearClasses(true, true, true);
  } else {
    clearClasses(true, true, true, true);
  }
});

function addBackButtons() {
  menuItemsWithChildrenContainer.forEach((container: HTMLElement) => {
    const subMenu = container.children[1];

    const backLi = document.createElement('li');
    const backA = document.createElement('a');
    backA.classList.add('menuBack');
    backA.innerText = 'Terug naar menu';
    backA.href = '#';

    backA.addEventListener('click', (event) => {
      event.preventDefault();
      clearClasses(true, true, true);
    });

    backLi.prepend(backA);
    subMenu.prepend(backLi);
  });
}

addBackButtons();
